import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Field } from "redux-form/immutable";
import { withStyles } from "@material-ui/core/styles";
import Brightness1 from "@material-ui/icons/Brightness1";
import { Grid, MenuItem } from "@material-ui/core";

import { BasePageTitle } from "altus-ui-components";

import {
  getMarkersFromState,
  getQualificationsFromState,
  getEmployeeGroupsFromState,
} from "features/planner/planner.selectors";

import TextField from "app/components/form/TextField";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import Marker from "features/planner/components/Card/EmployeeCard/Marker";
import { UPDATE_EMPLOYEE_FORM } from "features/planner/employee/employee.constants";

class EmployeeForm extends PureComponent {
  render() {
    const {
      classes,
      markers,
      qualifications,
      employeeGroups,
      availableMarkers,
    } = this.props;

    return (
      <Grid
        item
        xs={6}
        lg={4}
        container
        direction="column"
        className={classes.formRoot}
      >
        <Grid item>
          <BasePageTitle title="Employee" />
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs>
            <Field
              defaultValue="-"
              label="Employee no."
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.EMPLOYEE_NUMBER}
            />
          </Grid>
          <Grid item xs>
            <Field
              defaultValue="-"
              label="Department code"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.DEPARTMENT_CODE}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Field
            defaultValue="-"
            label="Job title"
            component={ReadOnlyField}
            name={UPDATE_EMPLOYEE_FORM.JOB_TITLE}
          />
        </Grid>
        <Grid item>
          <Field
            defaultValue="-"
            label="Work location"
            component={ReadOnlyField}
            name={UPDATE_EMPLOYEE_FORM.WORK_LOCATION}
          />
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs>
            <Field
              defaultValue="-"
              label="Organization"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.DEPARTMENT_NAME}
            />
          </Grid>
          {/*
          <Grid item xs>
            <Field
              label="Shift"
              defaultValue="-"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.SHIFT}
            />
          </Grid>
          */}
        </Grid>
        <Grid item>
          <Field
            select
            label="Qualification"
            component={TextField}
            name={UPDATE_EMPLOYEE_FORM.QUALIFICATION}
            SelectProps={{
              classes: {
                select: classes.select,
              },
            }}
          >
            <MenuItem value={null}>None</MenuItem>
            {qualifications.map(qualification => (
              <MenuItem
                key={qualification.get("id")}
                value={qualification.get("id")}
              >
                <Grid container alignItems="center" spacing={1}>
                  <Grid item className={classes.iconContainer}>
                    <Brightness1
                      fontSize="small"
                      style={{ color: qualification.get("backColor") }}
                    />
                  </Grid>
                  <Grid item>{qualification.get("name")}</Grid>
                </Grid>
              </MenuItem>
            ))}
          </Field>
        </Grid>
        <Grid item>
          <Field
            select
            component={TextField}
            label="Employee Group"
            name={UPDATE_EMPLOYEE_FORM.EMPLOYEE_GROUP}
          >
            <MenuItem value={null} key={-1} />
            {employeeGroups.map(employeeGroup => (
              <MenuItem
                key={employeeGroup.get("id")}
                value={employeeGroup.get("id")}
              >
                {employeeGroup.get("name")}
              </MenuItem>
            ))}
          </Field>
        </Grid>
        <Grid container>
          {markers
            .keySeq()
            .toJS()
            .map(index => {
              return (
                <Grid
                  item
                  xs={6}
                  key={index}
                  className={classes.markerFormItem}
                >
                  <Field
                    select
                    component={TextField}
                    label={`Marker ${index}`}
                    name={`${UPDATE_EMPLOYEE_FORM.MARKERS}.${index.toString()}`}
                    SelectProps={{
                      classes: {
                        select: classes.select,
                      },
                    }}
                  >
                    <MenuItem value={null}>None</MenuItem>
                    {availableMarkers.map(marker => (
                      <MenuItem
                        key={marker.get("id")}
                        value={marker.get("id").toString()}
                      >
                        <Grid container alignItems="center">
                          <Grid item className={classes.listItemIcon}>
                            <Marker marker={marker} />
                          </Grid>
                          <Grid item>{marker.get("name")}</Grid>
                        </Grid>
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {},
  select: {
    display: "flex",
    alignItems: "center",
  },
  markerFormItem: {
    "&:nth-child(even)": {
      paddingLeft: theme.spacing(1),
    },
    "&:nth-child(odd)": {
      paddingRight: theme.spacing(1),
    },
  },
  iconContainer: {
    display: "flex",
  },
  listItemIcon: {
    width: "1rem",
    height: "1rem",
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
});

export default compose(
  connect(state => ({
    availableMarkers: getMarkersFromState(state),
    qualifications: getQualificationsFromState(state),
    employeeGroups: getEmployeeGroupsFromState(state),
  })),
  withStyles(styles),
)(EmployeeForm);
